import Redirect from '@bottlebooks/gatsby-theme-event/src/components/Redirect';
import { graphql } from 'gatsby';
import React from 'react';

export default function FavoritesRoute({ data, ...rest }) {
  return <Redirect to={`/${data.locale.code}/my/bookmarks`} />;
}
export const fragment = graphql`
  query FavoritesRedirectRoute {
    locale {
      code
    }
  }
`;
